import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import CustomModal from '../customModal';
import QrCode from '../qrCode';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    width: 500,
    height: 526,
    [breakpoints.up('xl')]: {
      height: 680,
    },
  },
  disableRoot: {
    height: 323,
  },
  buttonsWrapper: {
    marginTop: spacing(12),
  },
  qrWrapper: {
    height: 492,
  },
  title: {
    paddingRight: 0,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    fontSize: 24,
  },
}));

const QrCodeDialog = ({
  translations,
  has2FA,
  hasError = false,
  hasRecoveryCodes = false,
  errorMessage = '',
  isOpened,
  is2FARequired = false,
  label = '',
  secret = '',
  onClose,
  handleDownload = () => {},
  onConfirm,
}) => {
  const classes = useStyles();
  const [otpCode, setOtpCode] = useState('');
  const disableTitle = is2FARequired
    ? translations.resetTitle
    : translations.disableTitle;
  const disableDescription = is2FARequired
    ? translations.resetDescription
    : translations.disableDescription;

  const getQRCodeSize = () => {
    if (window.innerWidth <= 1440) return 100;
    return 200;
  };

  const handleChange = e => {
    setOtpCode(e.target.value);
  };

  useEffect(() => {
    setOtpCode('');
  }, [isOpened]);

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(otpCode);
  };

  return (
    <CustomModal
      paperClass={classNames(classes.root, {
        [classes.disableRoot]: has2FA && !hasRecoveryCodes,
      })}
      buttonsWrapperClass={classNames({ [classes.buttonsWrapper]: !has2FA })}
      titleClass={classes.title}
      title={
        has2FA && !hasRecoveryCodes ? disableTitle : translations.setupTitle
      }
      description={has2FA && !hasRecoveryCodes ? disableDescription : ''}
      closeButtonLabel={translations.closeButton}
      confirmButtonLabel={translations.confirmButton}
      isOpened={isOpened}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <QrCode
        customWrapperClass={classes.qrWrapper}
        translations={translations}
        showQRCode={!has2FA || hasRecoveryCodes}
        hasRecoveryCodes={hasRecoveryCodes}
        label={label}
        secret={secret}
        otpCode={otpCode}
        size={getQRCodeSize()}
        hasError={hasError}
        errorMessage={errorMessage}
        handleChange={handleChange}
        handleDownload={handleDownload}
      />
    </CustomModal>
  );
};

QrCodeDialog.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  has2FA: PropTypes.bool.isRequired,
  hasRecoveryCodes: PropTypes.bool,
  is2FARequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  secret: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  handleDownload: PropTypes.func,
  hasError: PropTypes.bool,
};

export default QrCodeDialog;
